import React from "react";
import "./card.scss";
import {useState} from "react";

export default function Card(props){
      const path=`/assets/${props.canName}.png`;
      const [showFullText, setShowFullText] = useState(false);

       const toggleFullText = () => {
        setShowFullText(!showFullText);
       };

  return(
    <div className="card" >
       <div className="band">
         <div className="num">{props.band}</div>
         <div className="bandtext">Bands</div>
       </div>
       <div className="maincard">
         <img src={path} className="test-img"/>
         <div className="description"><div>{showFullText ? (
          <div className="long-text">
            {props.string} <a href="#" onClick={toggleFullText}>Read less</a>
          </div>
        ) : (
          <div className="short-text">
            {props.string.substring(0, 165)}...
            <a href="#" onClick={toggleFullText}>Read more</a>
          </div>
        )}</div>
         <div className="SName">{props.fullname}</div>
         </div>
       </div>
    </div>
  )
}
